import styled from 'styled-components';

export const PasswordHelpText = styled.div<{
  $showHelperText: boolean;
  $margin?: string;
}>`
  height: ${({ $showHelperText }) => ($showHelperText ? 'auto' : '0')};
  display: ${({ $showHelperText }) => ($showHelperText ? 'flex' : 'none')};
  margin-top: 8px;
  gap: 5px;
  flex-direction: column;
  margin: ${({ $margin }) => $margin};
`;

export const ButtonWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
